const maxFileSizeInMegaBytes = 5;
const maxFileSizeInBytes = maxFileSizeInMegaBytes * 1024 * 1024;

const imageExtensions = ["jpg", "jpeg", "png"];

export const validateDriverDocuments = (documents) => {
  let errors = [];
  Object.keys(documents).forEach((id) => {
    var document = documents[id];
    switch (document.id) {
      case "image": {
        if (document.file.size > maxFileSizeInBytes) {
          errors.push("Profile Image size should be less than 5MB");
        }
        var extension = document.file.name.split(".").pop();
        if (!imageExtensions.includes(extension)) {
          errors.push(`Profile Image should contain one of ${imageExtensions}`);
        }
        break;
      }
      default: {
        if (document.file.size > maxFileSizeInBytes) {
          errors.push(`${document.id} size should be less than 5MB`);
        }
        var extension = document.file.name.split(".").pop();
        if (!["pdf", ...imageExtensions].includes(extension)) {
          errors.push(
            `${document.id} should contain one of ${[
              ...imageExtensions,
              "pdf",
            ]}`
          );
        }
      }
    }
  });
  return errors;
};
